import DapDSCardTitle from './card-title.component'

export * from './card-title.component'
export default DapDSCardTitle

DapDSCardTitle.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-card-title': DapDSCardTitle
  }
}
